// ============================================================
// AssistantBar-Engine — Aktivitäts-Label während Tool-Ausführung.
// 1:1 aus AssistantBar.js (Vanilla) hierher verschoben.
// ============================================================
import { t } from '../../../i18n/index.js';

// ── Aktivitäts-Anzeige während Tool-Ausführung ──────────────
// Grobe Kategorie aus dem (internen) Werkzeugnamen — der Nutzer sieht nie
// den Namen selbst, nur ein übersetztes Label. Headless (mobiler Orb) geht
// das Label per Callback an den Chip; im offenen Panel ersetzt es kurz den
// «Ich höre zu»-Hinweis.
export function activityLabel(name: unknown): string {
  const n = String(name || '');
  const key = n.includes('offer') ? 'offer'
    : (n.includes('invoice') || n.includes('payment') || n.includes('dunning')) ? 'invoice'
    : (n.includes('customer') || n.includes('contact') || n.includes('lead')) ? 'customer'
    : (n.includes('email') || n.includes('mail')) ? 'email'
    : n.includes('whatsapp') ? 'whatsapp'
    : (n.includes('appointment') || n.includes('calendar') || n.includes('event')) ? 'calendar'
    : 'generic';
  return t('assistant.activity.' + key);
}
